import LayoutWrapper from "../layout/LayoutWrapper";
import { Routes, Route } from "react-router-dom";
import Cameras from "./Cameras";
import Clients from "./Clients";
import EmailReports from "./EmailReports";
import Previsiones from "./Previsiones";
import Users from "./Users";
import AdminRoute from "../routes/AdminRoute";
import PigCounter from "../components/PigCounter";
import DashboardHome from "./DashboardHome";

export default function Dashboard() {
  return (
    <LayoutWrapper>
      <Routes>
        <Route path="" element={<DashboardHome />} />
        <Route path="cameras" element={<Cameras />} />
        <Route path="previsiones" element={<Previsiones />} />
        <Route path="pig-counter/:id" element={<PigCounter />} />

        <Route
          path="email-reports"
          element={
            <AdminRoute>
              <EmailReports />
            </AdminRoute>
          }
        />
        <Route
          path="clients"
          element={
            <AdminRoute>
              <Clients />
            </AdminRoute>
          }
        />
        <Route
          path="users"
          element={
            <AdminRoute>
              <Users />
            </AdminRoute>
          }
        />
      </Routes>
    </LayoutWrapper>
  );
}
